// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
/** The contest a navigation to the voting screen asks to open, if any. */
export var getEditContestId = function (state) {
    if (typeof state !== "object" || state === null) {
        return undefined;
    }
    var editContestId = state.editContestId;
    return typeof editContestId === "string" ? editContestId : undefined;
};
